import { DisplayFees } from 'components/business/offering/DisplayFees';
import { IconFee } from 'ui/icons';
import { IconInvoice } from '@tock/icons';
import { consumer } from '@tock/coretypes';
import { useIsSakeIconSetEnabled } from 'omakase/utils/IconMigrationUtil';
import OfferingDetailsMetadataItem from 'components/business/offering/OfferingDetailsMetadataItem';
import React from 'react';

export interface OfferingDetailsFeesProps {
  fees: consumer.IOfferingFee[];
}

export const OfferingDetailsFees: React.FC<OfferingDetailsFeesProps> = ({ fees }) => {
  const isSakeIconSetEnabled = useIsSakeIconSetEnabled();

  return (
    <OfferingDetailsMetadataItem
      icon={isSakeIconSetEnabled ? IconInvoice : IconFee}
      data-testid="fee-details"
    >
      <DisplayFees fees={fees} />
    </OfferingDetailsMetadataItem>
  );
};
